export const kboFlowRunDetailColors = {
    ink: "#101828",
    muted: "#667085",
    blue: "#315ED6",
    blueSoft: "#EEF3FF",
    green: "#078653",
    greenSoft: "#EAF8F1",
    orange: "#C4510C",
    orangeSoft: "#FFF6ED",
    // This app's custom `palette.white` is not a CSS color value.
    white: "#FFFFFF",
} as const;
